import { TRANSACTION_FIELDS as o } from "../../TransactionsOverview/components/TransactionsTable/TransactionsTable.js";
const _ = "adyen-pe-transaction-data", s = `${_}__amount`, E = `${_}__action-bar`, N = `${_}__container`, a = `${_}__head-container`, t = `${_}__input`, T = `${t}-container`, D = `${T}--short`, O = `${T}--text-input`, R = `${T}--with-error`, S = `${t}-head`, r = `${_}__label`, I = `${_}__list`, A = `${_}__payment-method`, X = `${A}-detail`, c = `${A}-logo`, $ = `${c}-container`, i = `${_}__tags`, d = `${_}__status-box`, u = `${_}__refund-response`, n = `${_}__refund-response-icon`, C = `${n}--success`, P = `${n}--error`, U = `${_}__refund-statuses-container`, p = /* @__PURE__ */ new Set([
  "status",
  "category",
  "paymentMethod",
  "bankAccount",
  "balanceAccount",
  "id",
  "balanceAccountId",
  ...o,
  "deductedAmount",
  "lineItems",
  "originalAmount",
  "paymentPspReference",
  "refundDetails",
  "refundMetadata"
]);
export {
  E as TX_DATA_ACTION_BAR,
  s as TX_DATA_AMOUNT,
  _ as TX_DATA_CLASS,
  N as TX_DATA_CONTAINER,
  a as TX_DATA_HEAD_CONTAINER,
  t as TX_DATA_INPUT,
  T as TX_DATA_INPUT_CONTAINER,
  D as TX_DATA_INPUT_CONTAINER_SHORT,
  O as TX_DATA_INPUT_CONTAINER_TEXT,
  R as TX_DATA_INPUT_CONTAINER_WITH_ERROR,
  S as TX_DATA_INPUT_HEAD,
  r as TX_DATA_LABEL,
  I as TX_DATA_LIST,
  A as TX_DATA_PAY_METHOD,
  X as TX_DATA_PAY_METHOD_DETAIL,
  c as TX_DATA_PAY_METHOD_LOGO,
  $ as TX_DATA_PAY_METHOD_LOGO_CONTAINER,
  i as TX_DATA_TAGS,
  p as TX_DETAILS_RESERVED_FIELDS_SET,
  u as TX_REFUND_RESPONSE,
  P as TX_REFUND_RESPONSE_ERROR_ICON,
  n as TX_REFUND_RESPONSE_ICON,
  C as TX_REFUND_RESPONSE_SUCCESS_ICON,
  U as TX_REFUND_STATUSES_CONTAINER,
  d as TX_STATUS_BOX
};
